import axios from 'axios';

export const fetchEmployer403bData = async (employerName) => {
  const url = `${process.env.REACT_APP_API_BASE_URL}public403b/data/${employerName}`;
  const response = await axios.get(url);
  return response.data;
};
